enum AveryTemplateEnum {
    AVERY_5160 = "avery_5160",
    AVERY_5163 = "avery_5163",
    AVERY_5167 = "avery_5167",
    AVERY_8163 = "avery_8163",
}

export default AveryTemplateEnum;
